
$w.onReady (function  ()  {
    $w ("#image122" ) .target =  "_self";
	$w ("#button175" ) .target =  "_self";
});


import { timeline } from 'wix-animations';

// Демонстрации
$w.onReady(function () {

	const target1 = $w('#button183');
	

	$w('#button183').onMouseIn(() => {

		timeline()
			.add(target1, { y: -5, x: 0, scale: 1, duration: 600, easing: 'easeOutCirc' })
			.play();
			
	})

	$w('#button183').onMouseOut(() => {

		const reset = { y: 0, x: 0, scale: 1, duration: 600, easing: 'easeOutCirc' };

		timeline()
			.add(target1, reset)
	
			.play();
			
	})
})